import styled from "styled-components";
import { colors } from "@literati/public-ui-shared-react";

import { Subscription } from "lib/api/subscription";

import Icon from "@/atoms/Icon";
import { getPossessiveName } from "utils/grammar";

import StepShipping from "components/Step/StepShipping";
import { ShippingValues } from "components/Step/stepTypes";

import {
  MembershipState,
  MembershipStep,
} from "components/Membership/membershipTypes";
import { shouldSkipReadingLevelStep } from "components/Membership/membershipUtil";

const getHeading = (childName?: string) => {
  return childName
    ? `Finally: Where is ${getPossessiveName(childName)} book box going?`
    : "Finally:  Where is this book box going?";
};

const SiteBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  width: 100%;
  height: 50px;
  color: ${colors.tealShade3};
  background: ${colors.mintTint4};
`;

export const MembershipStepShipping = (state: MembershipState) => {
  const childName = state.childName || state.subscription?.childName;
  const heading = getHeading(childName);

  const backButtonProps = {
    onClick:
      state.prevSlug === "reading-level" &&
      shouldSkipReadingLevelStep({ childAge: state.childAge })
        ? () => state.routeSkipPrevStep?.()
        : () => state.routePrevStep?.(),
  };

  return (
    <StepShipping
      {...state}
      heading={heading}
      initialValues={state?.shippingValues as ShippingValues}
      prependedContent={
        state.checkoutSession?.giftCode ? null : (
          <SiteBanner>
            <Icon name="checkmark-circle-outline" size="20px" />
            Order and payment successful!
          </SiteBanner>
        )
      }
      saveAddressToContext={!!state.checkoutSession?.giftCode}
      saveAddressToSubscription
      stepFooterProps={{ backButtonProps }}
      stepHeaderProps={{ backButtonProps }}
      subscription={state?.subscription as Subscription}
    />
  );
};

export const MEMBERSHIP_STEP_SHIPPING: MembershipStep = {
  component: MembershipStepShipping,
  id: "membership-id-shipping",
  slug: "shipping",
};

export const MEMBERSHIP_STEP_SHIPPING_SUPPRESS_BACK_BUTTON: MembershipStep = {
  ...MEMBERSHIP_STEP_SHIPPING,
  component: (state) => {
    const childName = state.childName || state.subscription?.childName;
    const heading = getHeading(childName);

    return (
      <StepShipping
        {...state}
        heading={heading}
        initialValues={state?.shippingValues as ShippingValues}
        prependedContent={
          <SiteBanner>
            <Icon name="checkmark-circle-outline" size="20px" />
            Order and payment successful!
          </SiteBanner>
        }
        saveAddressToSubscription
        subscription={state?.subscription as Subscription}
        stepFooterProps={{
          suppressBackButton: true,
        }}
        stepHeaderProps={{
          suppressBackButton: true,
        }}
      />
    );
  },
};

export default MEMBERSHIP_STEP_SHIPPING;
